var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-column",attrs:{"id":"app"}},[_c('Header'),_c('LoginBox',{attrs:{"title":"スタッフプレイ","part":"front"},on:{"onsubmit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }